import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Panel } from 'components/ui/index';
import { intlShape, injectIntl } from 'react-intl';
import { getTreeItemByKey } from 'utils/treeUtil';
import { setDepartment, toggleDepartmentDialog, updateUsers, addUsers, setEditUser, getCountryCallingCode, fetchEditUser, setPaginationLastPage, incrementPaginationTotal } from '../flow/action';
import EditAndAddForm from '../component/editAndAddForm';
import DepartmentDialog from '../component/departmentDialog';
import { getTeamIds } from '../flow/reselect';


class addEditView extends React.Component {
  componentDidMount() {
    const {
      dispatchFetchEditUser,
      editUser,
      history,
      selectedDepartmentId,
      selectedDepartmentText,
      dispatchSetDepartment
    } = this.props;
    const searchParams = queryString.parse(history.location.search);
    // if it is editing mode, then re-fetch user if editUser is empty
    if ((_.isEmpty(editUser) || _.isEmpty(selectedDepartmentId || _.isEmpty(selectedDepartmentText))) && searchParams.id && searchParams.action === 'edit') {
      const self = this;
      dispatchFetchEditUser(searchParams.id, (user) => {
        const { id, name } = getTreeItemByKey(self.props.teams, user.team_id);
        dispatchSetDepartment({
          department_id: id,
          department_name: name
        });
      });
    }
  }

  hasInvalidScope = (scope, editUser) => {
    if (scope === 'all') {
      if (editUser.deleted_at) {
        return editUser.deleted_at !== null;
      }
    }
    return scope === 'inactive';
  }

  goToUserListPage = () => {
    this.props.history.push('/setup/company-info/users');
  }

  handleCancel = () => {
    this.goToUserListPage();
  }

  handleSubmit = () => {
    const isAddUserMode = _.isEmpty(this.props.editUser);

    if (isAddUserMode) {
      // the new created user is in the last page
      this.props.incrementPaginationTotal();
      this.props.setPaginationLastPage();
    }

    this.goToUserListPage();
  }

  render() {
    const {
      timeZones,
      moments,
      editUser,
      selectedDepartmentId,
      selectedDepartmentText,
      isDisplayDepartmentDialog,
      dispatchSetDepartment,
      dispatchToggleDepartmentDialog,
      dispatchAddUsers,
      dispatchUpdateUsers,
      dispatchGetCountryCallingCode,
      teams,
      teamIds,
      scope,
    } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <Panel contentClasses="pl-lg pr-lg" panelTitle={_.isEmpty(editUser) ? formatMessage({ id: 'page.users.addUser' }) : formatMessage({ id: 'page.users.editUser' })} >
        <EditAndAddForm
          disableSubmitBtn={this.hasInvalidScope(scope, editUser)}
          editObject={editUser}
          addUsers={dispatchAddUsers}
          getCountryCallingCode={dispatchGetCountryCallingCode}
          updateUsers={dispatchUpdateUsers}
          toggleDepartmentDialog={dispatchToggleDepartmentDialog}
          timeZones={timeZones}
          moments={moments}
          selectedDepartmentId={selectedDepartmentId}
          selectedDepartmentText={selectedDepartmentText}
          onCancel={this.handleCancel}
          teamIds={teamIds}
          onSubmit={this.handleSubmit}
        />
        <DepartmentDialog isDisplayDepartmentDialog={isDisplayDepartmentDialog} toggleDepartmentDialog={dispatchToggleDepartmentDialog} setDepartment={dispatchSetDepartment} teams={teams} />
      </Panel>
    );
  }
}
addEditView.propTypes = {
  intl: intlShape.isRequired,
  actionType: PropTypes.string.isRequired,
};

const mapStateToProps = ({ setup, global }) => ({
  scope: setup.users.users.scope,
  teams: global.settings.teams,
  timeZones: global.settings.timeZones,
  moments: global.settings.moments,
  editUser: setup.users.users.editUser,
  selectedDepartmentId: setup.users.users.department_id,
  selectedDepartmentText: setup.users.users.department_name,
  isDisplayDepartmentDialog: setup.users.ui.isDisplayDepartmentDialog,
  teamIds: getTeamIds({ global }),
});
const mapDispatchToProps = {
  dispatchSetDepartment: setDepartment,
  dispatchToggleDepartmentDialog: toggleDepartmentDialog,
  dispatchAddUsers: addUsers,
  dispatchUpdateUsers: updateUsers,
  dispatchGetCountryCallingCode: getCountryCallingCode,
  setEditUser,
  dispatchFetchEditUser: fetchEditUser,
  setPaginationLastPage,
  incrementPaginationTotal
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(addEditView)));




// WEBPACK FOOTER //
// ./src/views/Setup/Users/container/addView.jsx